import React, { useRef, useEffect } from 'react';
import ChatMessage from './ChatMessage';
import { useSelector } from 'react-redux';
import { ReactComponent as IconClose } from "../../images/svg/close.svg";
import { ReactComponent as IconSend } from "../../images/svg/send.svg";
import { ReactComponent as InfoErrorIcon } from "../../images/svg/Information-red.svg";

const ChatPanel = ({ 
  messages = [], 
  userId, 
  messageInput, 
  setMessageInput, 
  send, 
  sendChatReaction,
  onClose, 
  getAvatarColor,
  replyingTo,
  setReplyingTo
}) => {
  const messageAreaRef = useRef(null);
  const messagesListEndRef = useRef(null);
  const disableChat = useSelector(state => state.participants?.disableChat ?? false);

  const scrollToBottom = () => {
    const chatContainer = document.querySelector('.chat-message-list-container');
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, replyingTo]);

  const handleSend = (e) => {
    e.preventDefault();
    send(e, replyingTo);
    setReplyingTo(null);
    setMessageInput('');
    setTimeout(scrollToBottom, 100);
  };

  const handleReply = (messageId) => {
    const messageToReply = messages.find(m => m.messageId === messageId);
    if (messageToReply) {
      setReplyingTo(messageToReply.messageId);
      setTimeout(() => {
        const inputElement = document.getElementById('message');
        if (inputElement) {
          inputElement.focus();
        }
      }, 0);
    }
  };

  const handleChatReaction = (messageId, reaction) => {
    sendChatReaction(messageId, reaction);
  };

  const renderReplyPreviewContent = (messageId) => {
    const replyMessage = messages.find(m => m.messageId === messageId);
    if (!replyMessage) return '';

    const content = replyMessage.content;
    if (typeof content === 'object' && content.type === 'FILE') {
      return `File: ${content.fileName}`;
    }
    return content;
  };

  return (
    <div className="chat-container">
      <div className="chat-header">
        <div className="chat-header-content">Chat</div>
        <span className="chat-header-close" onClick={onClose}>
          <IconClose />
        </span>
      </div>
      <div className="chat-message-list-wrapper">
        <div className="chat-message-list-container">
          <div className="chat-message-list">
            <ul id="messageArea" ref={messageAreaRef}>
              {messages.map((message, index) => (
                <ChatMessage 
                  key={message.messageId || index}
                  message={message}
                  isSelf={message.sender === userId}
                  getAvatarColor={getAvatarColor}
                  onReply={handleReply}
                  onReaction={handleChatReaction}
                  allMessages={messages}
                />
              ))}
            </ul>
            <div id="messagesListEnd" ref={messagesListEndRef}></div>
          </div>
        </div>
      </div>

      {!disableChat ?? false ? (
        <>
          {replyingTo && (
            <div className="reply-preview">
              <div className="reply-preview-content">
                <span className="reply-to">
                  Replying to {messages.find(m => m.messageId === replyingTo)?.name}
                </span>
                <div className="reply-text">
                  {renderReplyPreviewContent(replyingTo)}
                </div>
              </div>
              <button 
                type="button" 
                className="cancel-reply" 
                onClick={() => setReplyingTo(null)}
              >
                ×
              </button>
            </div>
          )}
          <form id="messageForm" onSubmit={handleSend}>
            <div className="input-group">
              <input
                type="text"
                id="message"
                placeholder={replyingTo ? "Type your reply..." : "Type a message"}
                autoComplete="off"
                autoFocus
                className="form-control"
                value={messageInput}
                onChange={(e) => setMessageInput(e.target.value)}
              />
              <span className={`send-button ${messageInput ? 'active' : ''}`} onClick={handleSend}>
                <IconSend />
              </span>

            </div>
          </form>
        </>
      ) : (
        <div className="chat-disabled">
          <div className="chat-disabled-content">
            <InfoErrorIcon />
            <span>Message sending is disabled by host</span>
          </div>
          {/* <form id="messageForm" >
            <div className="input-group">
              <input
                disabled
                type="text"
                id="message"
                placeholder={replyingTo ? "Type your reply..." : "Type a message"}
                autoComplete="off"
                autoFocus
                className="form-control"
                value={messageInput}
                onChange={(e) => setMessageInput(e.target.value)}
              />
              <span className={`send-button ${messageInput ? 'active' : ''}`} >
                <IconSend />
              </span>

            </div>
          </form> */}
        </div>
      )}
    </div>
  );
};

export default ChatPanel;